module.exports = __webpack_public_path__ + "fonts/dystopian-regular.52316fd3.woff";